import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: "app-package-filter-modal",
  templateUrl: "./package-filter-modal.component.html",
  styleUrls: ["./package-filter-modal.component.scss"],
})
export class PackageFilterModalComponent implements OnInit {
  @Input() filters = [];
  @Output() close = new EventEmitter();
  @Output() applyFilters = new EventEmitter<any>();
  public tempFilters: any = [];
  selectedFilter: any;
  constructor() {}

  ngOnInit() {
    // console.log('filters>>>>', this.filters);
    this.tempFilters = JSON.parse(JSON.stringify(this.filters));
    let index = this.tempFilters.findIndex(f => !f.hideInModal)
    this.selectedFilter =  this.tempFilters[index];
  }

  public onSelectFilter(filter) {
    this.selectedFilter = filter;
  }

  public toggleOption(filter: any, option: any) {
    if ("selected" in option) {
      option.selected = !option.selected;
    }
  }

  public isAllSelected(group): boolean {
    return group.options.every((opt) => opt.checked || opt.selected);
  }

    public selectDeselectAll(group) {
      console.log('selectDeselectAll', group)
    if (group.options) {
      if (group.options.find(o => o.selected)) {
        group.options.forEach((o) => o['selected'] = false)
      } else {
        group.options.forEach((o) => o['selected'] = true)
      }
    }
  }

  public getSelectedCount(group: any): number {
  if (!group.options) return 0;
  return group.options.filter(o => o.selected).length;
  }

  public clearAll() {
    this.tempFilters.forEach(g => {
      if (g.hideInModal) return;
      g.options.forEach(o => {
        o['selected'] = false;
      })
    })
  }

  public applyFilter() {
    const selectedResult = this.tempFilters.map((group) => ({
      type: group.type,
      label: group.label,
      selected: group.options.filter((opt) => opt.selected),
    }));

    const fullState = JSON.parse(JSON.stringify(this.tempFilters));

    this.applyFilters.emit({
      allFilters: fullState,
      selectedFilters: selectedResult,
    });
  }

  public closeModal() {
    this.close.emit();
  }
}
